const rootClass = 'weet-components-input-number';
export { rootClass };
